

















import { defineComponent, reactive, computed } from '@vue/composition-api'
export default defineComponent({
  props: {
    title: {
      required: true
    },
    content: { required: true },
    image: { required: true },
    isOpened: { required: true }
  },
  setup(props, { emit }) {
    const opened = computed({
      get: () => props.isOpened,
      set: value => emit('close', value)
    })
    return {
      opened
    }
  }
})
